<template lang="pug">
div
  modal.active(
    :active='showModal'
    @close='$router.back()',
    title='Encerrar publicação'
  )
    div(slot='modal-body')
      h5 Tem certeza?
      p Se confirmar a publicação vai ser encerrada, os documentos vinculados serão dado ciência como diário oficial.
      p.text-error Depois que confirmar não poderá ser desfeito.
    .columns.align-center(slot='modal-footer')
      .column
      .column-col-auto
        button.btn.btn-primary(
          :class='{ loading }'
          @click='onConfirm'
        )
          btn-content(name='confirm' label="Encerrar")
</template>

<script>
import toastErrors from '@/lib/errors/toastErrors'

export default {
  vuex: {
    'fiscalizacao/docPublicacoes': {
      state: ['current', 'loading', 'status'],
      actions: ['fetchEncerrar'],
    },
  },
  data() {
    return {
      showModal: true,
    }
  },
  methods: {
    async onConfirm() {
      try {
        await this.fetchEncerrar(this.current.id)
        this.$toaster.success('Encerrado com sucesso')
        this.$router.back()
      } catch (e) {
        toastErrors(e)
      }
    },
  },
}
</script>
